import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login/login';
import Dashboard from '../pages/Dashboard/Dashboard';
import CryptoTest from '../pages/CryptoTest/CryptoTest';
import AppLayout from '../layouts/Applayout';
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route element={<AppLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/crypto-test" element={<CryptoTest />} />
      </Route>
    </Routes>
  );
}
